/**
 * The EditorDiscountTable component
 */
import React, { Component } from 'react';
import { Button, Col } from 'reactstrap';
import PropTypes from "prop-types";
import FormattedNumber from '../FormattedNumber';
import icon_discount from '../../assets/images/icons/discount.svg';
import DataLayerHelper from '../../utils/dataLayer'

/**
 * Stateless react component to render the EditorDiscountTable page
 * @param {Object} props the props passed to the page.
 */
class EditorDiscountTable extends Component {
  constructor(props) {
    super(props);

    this.openDiscountTable = this.openDiscountTable.bind(this);
    this.state = {
      discountTableOpen: false
    };
  }
  

  openDiscountTable() {
    this.setState({
      discountTableOpen: true
    });
    DataLayerHelper.addEvent('behaviour', 'open discount table')
  }


  render() {
    const { discounts, language } = this.props
    return (
      <div className="fileeditor_sidebar_discount row m-3 no-gutters" onClick={this.openDiscountTable}>
        <Col xs={2} className="px-2">
          <img style={{height: '3em'}} src={ icon_discount} alt={ 'Discount %' } loading="lazy" />
        </Col>
      <Col xs={10}>
          <p className="small">
            <strong>{this.context.t('Buy more, save more')}</strong><br />
            {this.context.t('Volume discount starts at the second item! The discount is already subtracted in the previewed price.')}<br />
          </p>
          <Button color="link" size="sm" className="float-right" onClick={this.openDiscountTable}>{this.context.t('show discount scale')}</Button>
          { this.state.discountTableOpen &&
            <table className="table small">
              { discounts.map((discount) => {
                return (
                  <tr>
                    <td>{this.context.t('from')} {discount.amount} {this.context.t('units')}</td>
                    <td><strong><FormattedNumber value={discount.percentage} language={language} unit="%" decimals={0} /> {this.context.t('discount')}</strong></td>
                  </tr>
                );
              })}
            </table>
          }
        </Col>
      </div>
    );
  }
}

/**  define proptype for the 'translation' function  */
EditorDiscountTable.contextTypes = {
  t: PropTypes.func
}

export default EditorDiscountTable;
